<template>
  <div style="background: #f8f8fb" class="p-5">
    <b-container class="hiddenItem">
      <div class="pr-5" v-if="candidateData">
        <b-row>
          <b-col>
            <div class="flexDiv bg-primary text-white p-3">
              <div class="flexDiv2">
                <div
                  class="avatar-md profile-user-wid mb-4"
                  v-if="candidateData.employeePhotoUploadPath"
                >
                  <img
                    width="100"
                    height="100"
                    :src="
                      candidateData.employeePhotoUploadPath
                        ? `${baseUrl}/${candidateData.employeePhotoUploadPath}`
                        : require('@/assets/user.jpg')
                    "
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                </div>
                <div
                  class="ml-3"
                  v-if="candidateData.firstName && candidateData.lastName"
                >
                  <h5 class="m-0">
                    {{ `${candidateData.lastName} ${candidateData.firstName}` }}
                  </h5>
                  <h5 v-if="candidateData.parentName">
                    {{ `${candidateData.parentName}` }}
                  </h5>
                  <p v-if="candidateData.phone" class="m-0">
                    {{ candidateData.phone }}
                  </p>
                </div>
              </div>
              <div class="mt-2 mr-3">
                <language />
                <b-button
                  @click="showAriza"
                  class="mt-1"
                  variant="outline-light"
                >
                  <i class="fa fa-file"></i>
                  {{ $t("showArizaInfo") }}
                </b-button>
                <b-button
                  v-if="
                    status != 'SEEN' &&
                    status != 'SEND_DOCUMENT' &&
                    status != 'TEST_PROCESS' &&
                    status != 'TEST'
                  "
                  @click="showTestResult"
                  class="mt-1 ml-2"
                  variant="outline-light"
                >
                  <i class="fa fa-eye"></i>
                  {{ $t("testAnswers") }}
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="bg-white">
          <table class="table table-bordered">
            <tr>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.birthDate") }}</p>
                <strong class="str">{{ candidateData.birthday }}</strong>
              </td>

              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.birthAddress") }}</p>
                <strong class="str">
                  {{
                    candidateData[$localeKey('birthCountryName')]
                  }}
                  {{
                    candidateData[$localeKey('birthRegionName')]
                  }}
                  {{
                    candidateData[$localeKey('birthDistrictName')]
                  
                  }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.propis") }}</p>
                <strong class="str">
                  {{
                    candidateData[$localeKey('directoryRegionAddressName')]
                  }},
                  {{ candidateData.address }}
                </strong>
              </td>
            </tr>
            <tr>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.exactAdress") }}</p>
                <strong class="str">
                  {{
                    candidateData[$localeKey('currentRegionAddressName')]
                  }}
                  {{ candidateData.currentAddress }}
                </strong>
              </td>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("seriaNumber") }}</p>
                <strong class="str">
                  {{ candidateData.passportSerialTitle }}
                  {{ candidateData.passportNumber }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.inpc") }}</p>
                <strong class="str">{{ candidateData.inps }}</strong>
              </td>
            </tr>
            <tr>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("INN") }}</p>
                <strong class="str">{{ candidateData.inn }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.nationality") }}</p>
                <strong class="str">
                  {{
                    candidateData[$localeKey('directoryNationalityName')]
                  }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0">{{ $t("references.gender") }}</p>
                <strong class="str">
                  {{
                    candidateData[$localeKey('directoryGenderName')]
                  }}
                </strong>
              </td>
            </tr>

            <tr>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("employees.passportGivenDate") }}</p>
                <strong class="str">{{
                  candidateData.passportGivenDate
                }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0">{{ $t("employees.passportEndDate") }}</p>
                <strong class="str">{{ candidateData.passportEndDate }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.passportTYpe") }}</p>
                <strong class="str">
                  {{
                    candidateData[$localeKey('passportTypeName')]
                  }}
                </strong>
              </td>
            </tr>

            <tr>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("references.marital_status") }}</p>
                <strong class="str">
                  {{
                    candidateData[$localeKey('directoryMaritalStatusName')]
                  }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.email") }}</p>
                <strong class="str">{{ candidateData.email }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.mobilePhone") }}</p>
                <strong class="str">{{ candidateData.mobilePhone }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <candidateFiles class="mr-5" />
    </b-container>

    <b-modal
      class="hiddenItem"
      size="lg"
      body-class="p-0"
      id="modal-center"
      v-model="isarizaPdf"
      :hide-footer="true"
    >
      <div style="min-height: 400px">
        <b-overlay :show="loaderAriza" rounded="sm">
          <embed
            v-if="arizaPdf"
            height="500"
            width="100%"
            :src="`data:application/pdf;base64,${arizaPdf}`"
          />
        </b-overlay>
      </div>
    </b-modal>

    <b-modal
      hide-header
      size="xl"
      body-class="p-0"
      id="modal-center"
      v-model="isResult"
      :hide-footer="true"
    >
      <b-card no-body style="border: none" id="print">
        <b-card-header
          class="text-center p-3 bg-primary hiddenItem"
          style="display: flex; justify-content: space-between"
        >
          <h2 class="text-white">{{ $t("testResult") }}</h2>
          <b-button-group>
            <b-button variant="outline-light" @click="print()">
              <i class="fa fa-print"></i>
              {{ $t("actions.print") }}
            </b-button>
            <b-button variant="outline-light" @click="cancelTestResult()">
              <i style="font-size: 20px" class="fa fa-times"></i>
            </b-button>
          </b-button-group>
        </b-card-header>
        <div v-if="isLoader" class="text-center hiddenItem">
          <b-spinner label="Loading..."></b-spinner>
        </div>

        <div v-if="!isLoader" ref="document">
          <div class="d-flex pl-4 pr-4 pt-4 pb-0">
            <div class="mt-1">
              <h5 class="mb-3">
                {{ $t("EmployeeFIO") }}:
                <strong v-if="candidateData">
                  {{ candidateData.lastName }}
                  {{ candidateData.firstName }}

                  {{ candidateData.parentName }}
                </strong>
              </h5>
              <h5 class="mb-3">
                {{ $t("allTest") }}:
                <strong>30</strong>
              </h5>
              <h5 class="mb-3">
                {{ $t("allTestCorrect") }}:
                <strong v-if="testEmployee">{{ testEmployee.corrects }}</strong>
              </h5>
              <h5 class="mb-3">
                {{ $t("allTestNoCorrect") }}:
                <strong>{{ noCorrect }}</strong>
              </h5>
            </div>
            <div class="text-center ml-5 pl-5" v-if="testEmployee">
              <radial-progress-bar
                :strokeWidth="20"
                :innerStrokeWidth="20"
                :diameter="200"
                :completed-steps="testEmployee.corrects"
                :total-steps="30"
                startColor="#007BFF"
                stopColor="#007BFF"
              >
                <h2>{{ testEmployee.correctsInProportion + "%" }}</h2>
              </radial-progress-bar>
              <h5 class="m-0">{{ 30 + "/" + testEmployee.corrects }}</h5>
            </div>
          </div>

          <b-card-body>
            <div
              v-for="(item, index) in questionsDto"
              :key="index"
              class="con pl-3 pr-3"
            >
              <h5 class="mb-4 mt-2">
                {{ index + 1 }}.
                {{
                  item[$localeKey()]
                }}
              </h5>
              <b-form-radio-group size="lg" v-model="isTrue">
                <b-form-radio
                  style="display: block"
                  v-for="(choice, i) in item.answers"
                  :disabled="!choice.isAnswer"
                  :key="i"
                  :value="choice.isSelect"
                >
                  <p style="line-height: 25px">
                    {{
                      choice[$localeKey()]
                    }}
                    <i
                      v-if="
                        choice.isSelect === true && choice.isAnswer === true
                      "
                      style="color: #038a04; font-size: 25px; margin-top: 5px"
                      class="fa fa-check"
                      aria-hidden="true"
                    ></i>
                    <i
                      v-if="
                        choice.isSelect === true && choice.isAnswer === false
                      "
                      style="color: #dd0f16; font-size: 25px"
                      class="fa fa-times"
                      aria-hidden="true"
                    ></i>
                  </p>
                </b-form-radio>
              </b-form-radio-group>
            </div>
          </b-card-body>
        </div>
      </b-card>
    </b-modal>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import language from "./languageCadr";
import candidateFiles from "./candidateFiles";
import vacancyService from "@/services/vacancy.service";
import TestResult from "./testResult";
import RadialProgressBar from "vue-radial-progress";

export default {
  props: ["staffId", "status"],
  data() {
    return {
      loaderAriza: false,
      isarizaPdf: false,
      isResult: false,
      noCorrect: null,
      isLoader: false,
      isShow: true,
      isTrue: true,
      questionsDto: null,
      testEmployee: null,
    };
  },
  components: {
    candidateFiles,
    language,
    // TestResult,
    // RadialProgressBar,
  },
  computed: {
    ...mapState("vacancy", ["arizaPdf"]),
    ...mapState("employee", ["candidateData"]),
    ...mapState("employee", ["employee", "candidateData", "modalClose"]),
  },

  methods: {
    cancelTestResult() {
      this.isResult = false;
    },
    // print(divName) {
    //   var printContents = document.getElementById(divName).innerHTML;
    //   var originalContents = document.body.innerHTML;
    //
    //   document.body.innerHTML = printContents;
    //
    //   window.print();
    //
    //   document.body.innerHTML = originalContents;
    // },
    print() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("print").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=1000,height=1000,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
    },
    async getResult(id, vId) {
      try {
        this.isLoader = true;
        let res = await vacancyService.getTestResult(id, vId);
        await this.setResult(res.data ? res.data : null);
        this.isLoader = false;
      } catch (e) {
        await this.setResult(null);
      }
    },
    setResult(data) {
      this.$nextTick(() => {
        this.questionsDto = data.questionsDto;
        this.testEmployee = data.testEmployee;
        this.noCorrect = 30 - this.testEmployee.corrects;
      });
    },
    showTestResult() {
      this.isResult = true;
      setTimeout(() => {
        this.getResult(this.candidateData.id, this.staffId);
      }, 200);
    },
    getArizaPdf(emplId) {
      this.loaderAriza = true;
      this.isarizaPdf = true;

      vacancyService.getArizaPdf(emplId, this.staffId).then(async (res) => {
        await this.$store.commit("vacancy/setArizaPdf", res.data);
        this.loaderAriza = false;
      });
    },
    showAriza() {
      setTimeout(async () => {
        await this.getArizaPdf(this.candidateData.id);
      }, 200);
    },
  },
};
</script>

<style>
.str {
  font-size: 15px !important;
}

.fo {
  font-size: 14px !important;
}

.flexDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flexDiv2 {
  display: flex;
  align-items: center;
}

@media print {
  .hiddenItem {
    display: none !important;
  }
}
</style>
